"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var preview_1 = __importDefault(require("./preview"));
var preview = new preview_1.default();
var rawStoriesOf = preview.api().storiesOf.bind(preview);
exports.setAddon = preview.api().setAddon.bind(preview);
exports.addDecorator = preview.api().addDecorator.bind(preview);
exports.addParameters = preview.api().addParameters.bind(preview);
exports.clearDecorators = preview
    .api()
    .clearDecorators.bind(preview);
exports.configure = preview.configure;
exports.getStorybook = preview.api().getStorybook.bind(preview);
exports.getStorybookUI = preview.getStorybookUI;
exports.raw = preview.api().raw.bind(preview);
exports.storiesOf = function (kind, module) {
    return rawStoriesOf(kind, module).addParameters({ framework: 'react-native' });
};
